/* eslint-disable max-len */
import React from 'react';

interface ITurnOnProps {
    width?: number | string;
    height?: number | string;
}

const TurnOn: React.FC<ITurnOnProps> = ({width = 12, height = 12}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.81083 0.187092C2.4144 -0.0566584 1.91618 -0.0646941 1.51172 0.162984C1.10725 0.390663 0.855469 0.819234 0.855469 1.28531V10.7139C0.855469 11.1799 1.10725 11.6085 1.51172 11.8362C1.91618 12.0639 2.4144 12.0532 2.81083 11.8121L10.5251 7.09781C10.9081 6.86477 11.1412 6.44959 11.1412 5.99959C11.1412 5.54959 10.9081 5.13709 10.5251 4.90138L2.81083 0.187092Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default TurnOn;